<template>
    <v-app class="vuetify-layout">
        <v-navigation-drawer v-model="openSidebar"
        width="260"
        app
        clipped
        :mini-variant.sync="mini"
        :mini-variant-width="$vuetify.breakpoint.xs ? 94 : 86"
        mobile-breakpoint="600"
        hide-overlay
        :touchless="!$vuetify.breakpoint.xs"
        :permanent="!$vuetify.breakpoint.xs"
        >
            <v-list nav>
                <inertia-link href="/portal" @click="openSidebar = false">
                    <v-list-item
                    link :class="{'v-list-item--active' : $page.props.currentRouteName == 'portal.home.index' }"
                    id="dashboard">
                        <v-list-item-icon>
                            <v-icon>mdi-view-dashboard-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_dashboard || "Dashboard"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_dashboard || "Dashboard"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#dashboard" right open-delay="500">
                            <span>{{$page.props.lang.menu_dashboard || "Dashboard"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/portal/calendar" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('portal.calendar')}" id="calendar">
                        <v-list-item-icon>
                            <v-icon>mdi-calendar-month-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_calendar || "Calendar"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_calendar || "Calendar"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#calendar" right open-delay="500">
                            <span>{{$page.props.lang.menu_calendar || "Calendar"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>

                <inertia-link href="/portal/memberships" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('portal.memberships')}" id="memberships">
                        <v-list-item-icon>
                            <v-icon>mdi-account-details-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_memberships || "Članarine"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_memberships || "Članarine"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#calendar" right open-delay="500">
                            <span>{{$page.props.lang.menu_memberships || "Članarine"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>

                <inertia-link href="/portal/measurement" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('portal.measurement')}" id="measurement">
                        <v-list-item-icon>
                            <v-icon>mdi-chart-timeline-variant</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_measurement || "Measurement"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_measurement || "Measurement"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#measurement" right open-delay="500">
                            <span>{{$page.props.lang.menu_measurement || "Measurement"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/portal/profile" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('portal.profile')}" id="profile">
                        <v-list-item-icon>
                            <v-icon>mdi-account-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_profile || "Profile"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_profile || "Profile"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#profile" right open-delay="500">
                            <span>{{$page.props.lang.menu_profile || "Profile"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app class="navbar" clipped-left elevation="1" dark :style="{ backgroundColor : $page.props.organization.themeOptions.primary}">
            <div class="left d-flex align-center">
                <v-btn v-if="$vuetify.breakpoint.xs" elevation="1" fab small @click="openSidebar = !openSidebar">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
                <logo :logo="$page.props.organization.settings.main_logo_path"></logo>
            </div>
            <v-spacer />
            <div class="right">
                <v-menu offset-y origin="top right" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <div class="dropdown-button" elevation="1" v-bind="attrs" v-on="on">
                            <div class="info-wrap" v-show="!$vuetify.breakpoint.xs">
                                <p class="user-full-name">{{ $page.props.user.name }}</p>
                                <p class="user-organization">{{ $page.props.organization.name }}</p>
                            </div>
                            <v-avatar class="ml-1">
                                <img :src="$page.props.user.profile_photo_url + '?w=96'" :alt="$page.props.user.name" class="h-8 w-8 rounded-full object-cover"/>
                            </v-avatar>
                            <v-icon class="arrow">mdi-menu-down</v-icon>
                        </div>
                    </template>
                    <v-list expand nav>
                        <a @click="logout">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.signout || "Sign Out"}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </a>
                    </v-list>
                </v-menu>
            </div>
        </v-app-bar>

        <v-snackbars :objects.sync="messageObjects" top right>
            <template v-slot:action="{ close }">
                <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbars>

        <v-main app fluid absolute>
            <div class="slot" fluid>
                <slot name="header" class="page-header"></slot>
                <slot></slot>
            </div>
        </v-main>
        <v-footer padless color="#F9F9F9">
            <v-row justify="center" no-gutters>
                <v-col class="py-4 text-center" cols="12">
                    Powered by <a href="https://fitbrry.com?ref=portal">fitbrry.com</a>
                </v-col>
            </v-row>
        </v-footer>
    </v-app>
</template>

<script>
import Logo from '@/js/Components/Logo'
import EventBus from '../eventbus'

export default {
    name: "AppLayout",
    components: {
        Logo
    },
    data () {
        return {
            toggleMini: true,
            memberSubs:[],
            messageObjects: [],
            openSidebar: false
        }
    },
    computed: {
        mini: {
            get() {
                return this.toggleMini
            },
            set() {
                return this.toggleMini
            }
        },
        mobile() {
            return this.$vuetify.breakpoint.width < 600
        }
    },
    methods: {
        logout() {
            axios.post('/logout').then(() => {
                window.location = '/'
            })
        }
    },
    mounted() {
        if(sessionStorage.isMini) {
            this.toggleMini = JSON.parse(sessionStorage.isMini)
        }

        EventBus.$on('SHOW_NOTIFICATION', (p) => {
            this.messageObjects.push(p)
        })


    },
    beforeDestroy() {
        if (this.toggleMini===true) {
            sessionStorage.setItem('isMini', true)
        } else {
            sessionStorage.setItem('isMini', false)
        }
    },
    watch: {
        'this.$vuetify.breakpoint.width': (value) => {
            if(value < 600) {
                this.mobile = true
            }
        }
    }
}
</script>
